import { BackButton, Icon } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';

const HeaderResponsive = ({ onShowMobileMenu, onBack, title }) => {
  return (
    <div className="header-responsive">
      {onBack && <BackButton color="inverse" onClick={onBack} />}
      <div className="header-responsive__mobile-menu-header-title">{title}</div>
      <div className="header-responsive__mobile-menu-header-button" onClick={onShowMobileMenu}>
        <div>
          <Icon name="menu" size="xl" color="white" />
        </div>
      </div>
    </div>
  );
};

HeaderResponsive.propTypes = {
  onBack: PropTypes.func,
  onShowMobileMenu: PropTypes.func,
  title: PropTypes.string,
};

export default HeaderResponsive;
